/*---------------------------------------------------------------------------------------------
 *  Copyright (c) i-Bridge Systems Philippines Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { getTime } from 'date-fns';

// TIME RELATED - DESCENDING ORDER DEFAULT
export const sortByCheckInDate = (data) => {
  return data.sort(
    (a, b) => getTime(new Date(b.checkin)) - getTime(new Date(a.checkin))
  );
};

export const sortByCheckOutDate = (data) => {
  return data.sort(
    (a, b) => getTime(new Date(b.checkout)) - getTime(new Date(a.checkout))
  );
};

export const sortByComputedTime = (data) => {
  return data.sort((a, b) => b.roundedtime - a.roundedtime);
};

export const sortByLastLogInDate = (data) => {
  return data.sort(
    (a, b) =>
      getTime(new Date(b.lastlogindate)) - getTime(new Date(a.lastlogindate))
  );
};

// STRING DATA TYPE - ASCENDING ORDER DEFAULT
export const sortByEmpId = (data) => {
  return data.sort((a, b) => a.empid.localeCompare(b.empid));
};

export const sortByFirstName = (data) => {
  return data.sort((a, b) => a.firstname.localeCompare(b.firstname));
};

export const sortByLastName = (data) => {
  return data.sort((a, b) => {
    const sortedLastName = a.lastname.localeCompare(b.lastname);

    return sortedLastName !== 0
      ? sortedLastName
      : a.firstname.localeCompare(b.firstname);
  });
};

export const sortByUsername = (data) => {
  return data.sort((a, b) => a.username.localeCompare(b.username));
};

// export const sortByCountry = (data) => {
//   return data.sort((a, b) => a.country.localeCompare(b.country))
// }

export const sortByDeptName = (data) => {
  return data.sort((a, b) => a.deptname.localeCompare(b.deptname));
};
